import { useForm } from "react-hook-form";

export default function NuevaReservaForm({ onReservarPieza }) {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      id_referencia_plataforma: "",
    },
  });

  const handleSubmitNuevaReserva = async (data, e) => {
    e.preventDefault();
    onReservarPieza(data);
  };

  return (
    <div>
      <form
        className="form align-items-center"
        onSubmit={handleSubmit(handleSubmitNuevaReserva)}
      >
        <div className="w-100 d-flex flex-column flex-grow-1">
          <div className="form-group">
            <label htmlFor="id_referencia_plataforma">
              ID Referencia Plataforma
            </label>
            <input
              type="number"
              className="form-control"
              {...register("id_referencia_plataforma", { required: true })}
            />
            <div className="form-invalid">
              {errors.id_referencia_plataforma?.type === "required" &&
                "ID Referencia Plataforma es requerido"}
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center align-self-end mt-3">
          <button type="submit" className="btn btn-primary">
            Guardar
          </button>
        </div>
      </form>
    </div>
  );
}
